<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="lg">
        <div slot="modal-header" class="w-100">
            <div class="row">
                <div class="col-12">
                    <label>{{$t('expert2.field.documents')}}</label>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card card-form">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <div class="container-fluid">
                                        <carousel :perPage="1"
                                                  :navigationEnabled="true"
                                                  :navigationNextLabel="next"
                                                  :navigationPrevLabel="prev">
                                            <slide v-for="(photo) in documents" v-bind:key="photo.uuid">
                                                <div v-if="photo && photo.type !== 'application/pdf'">
                                                    <!--<img :src="photo.filePath" width="100%" style="height: 500px;" :style="rotateStyle" />-->
                                                    <inner-image-zoom :src="photo.filePath"
                                                                      :style="rotateStyle"
                                                                      width="100%"
                                                                      height="500px"
                                                                      hideHint="true"
                                                                      zoomScale="1.2"
                                                    ></inner-image-zoom>
                                                </div>
                                                <div v-else-if="photo && photo.type === 'application/pdf'">
                                                    <iframe :src="photo.filePath" width="100%" style="height: 600px"></iframe>
                                                </div>
                                            </slide>
                                        </carousel>
                                        <div class="text-center mt-3 d-flex justify-content-center">
                                            <button class="all-btn add-btn mr-3" @click="rotateRight">
                                                <i class="fa fa-mail-reply"></i>
                                            </button>
                                            <button class="all-btn add-btn" @click="rotateLeft">
                                                <i class="fa fa-mail-forward"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <loading :active.sync="loading" :is-full-page="true"></loading>
        </div>
        <div slot="modal-footer" style="width: 100%">
            <button class="all-btn delete-btn float-right mr-2" @click="show =!show">
                {{ $t("action.cancel") }}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import InnerImageZoom from 'vue-inner-image-zoom';
    import Loading from 'vue-loading-overlay';

    export default {
        name: "Expert2DocViewModal",
        components: {
            'b-modal': bModal,
            'inner-image-zoom': InnerImageZoom,
            Loading
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                loading: false,
                show: false,
                prev: '<i class="material-icons">keyboard_arrow_left</i>',
                next: '<i class="material-icons">keyboard_arrow_right</i>',
                expert2Id: null,
                expert2: null,
                documents: [],
                turn: 0
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.expert2Id;

                if (id && id > 0) {
                    this.loading = true;

                    this.$http.get(`admin/expert2/${id}`)
                        .then(res => {
                            vm.expert2 = res.data;
                            vm.expert2.report.forEach((file) => {
                                this.documents.push(file);
                            });
                            vm.expert2.cadastre.forEach((file) => {
                                this.documents.push(file);
                            });
                            vm.expert2.constructionCompletionDoc.forEach((file) => {
                                this.documents.push(file);
                            });
                            this.loading = false;
                        }, () => {
                            this.loading = false;
                        })
                }
            },
            rotateRight() {
                this.turn = this.turn - 0.25
            },
            rotateLeft() {
                this.turn = this.turn + 0.25
            }
        },
        created() {
            this.$eventBus.$on('showExpert2DocumentsModal', (expert2Id) => {
                if (expert2Id) {
                    this.expert2Id = expert2Id;
                    this.show = true;
                    this.documents = []
                    this.init()
                }
            })
        }
    }
</script>

<style scoped>

</style>